import React, { useState, useEffect } from 'react';
import {
    Grid,
    RadioGroup,
    Radio,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { ButtonLoading } from 'components';
import { useStyles } from './Style';
import TextItemDotted from '../TextItemDotted';
import WarratyTextDg from '../WarratyTextDg';
import clsx from 'clsx';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';
const RequestWarranty = (props) => {
    const { warrantyList,
        typeWarranty,
        setTypeWarranty,
        onNextTab,
        setPrice,
        radioList,
        setSelectedRadioWarrantyType,
        selectedRadioWarrantyType,
        onSelectWarranty = () => { },
        isLoadingSelectRadio,
        isErrorRadioWarrantyService,
    } = props;
    const classes = useStyles();
    const [isOpenDg, setIsOpenDg] = useState(false);
    /**
       * به ازای هر منوی کشویی این تابع اجرا میشود و منو و زیر منو را میسازد
       */
    const collpaseItem = (data, index) => {
        return <Grid xs={12} className={classes.colllapseTop} style={{ border: '1px solid #f4f4f4' }}>
            <Grid item xs={12} style={{ border: '1px solid #f4f4f4' }} className={classes.headItem} >
                <span>ضمانت‌نامه شرکت در مناقصه  </span>

            </Grid>
            <Grid className={classes.collpaseContent}>

                {
                    selectedRadioWarrantyType === 'PARTICIPATION_TENDERS' ? (
                        <>
                            <TextItemDotted title='سقف مالی ضمانت‌نامه' title2={data?.['amount-limit']} isPrice={true} />
                            <TextItemDotted title='سپرده نقدی' title2={data?.['cash-deposit-percentage']} />
                            <TextItemDotted title='کارمزد' title2={data?.['commission-percentage']} />
                            <TextItemDotted title='وثیقه' title2={data?.['collateral-percentage']} />
                        </>
                    ) : (<>
                        <TextItemDotted title='سقف مالی ضمانت‌نامه' title2='ندارد' />
                        <TextItemDotted title='سپرده نقدی' title2='به میزان مبلغ ضمانت نامه' />
                        <TextItemDotted title='کارمزد' title2={data?.['commission']} isPrice={true} />
                        <TextItemDotted title='وثیقه' title2='ندارد' />
                    </>)
                }

            </Grid>

        </Grid>;
    }

    const shimmerLoading = () => {
        return <Grid xs={12}
            className={classes.colllapseTop}
            style={{ border: '1px solid #f4f4f4' }}>
            <Grid item xs={12}
                style={{ border: '1px solid #f4f4f4', minHeight: '40px' }}
                className={classes.headItem} onClick={() => {
                }}>
                {/* <div className={clsx(classes.shimmerBG, classes.contentLine)}></div> */}

            </Grid>
            <Grid className={classes.collpaseContent} style={{ padding: '16px' }}>
                {
                    <>
                        <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
                        <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
                        <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
                        <div className={clsx(classes.shimmerBG, classes.contentLine)}></div>
                    </>
                }
            </Grid>

        </Grid>;
    }

    const handleChangeRadio = (check) => {

        setSelectedRadioWarrantyType(check?.target?.value)
        onSelectWarranty(check?.target?.value);
    }
    return (
        <>
            <Grid container spacing={3} style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid direction="column" spacing={3} container item xs={12} md={12} lg={10}>
                    <Grid item md={6} xs={12}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'justify',
                            marginTop: '16px'
                        }}>
                        {radioList?.length > 0 && <Grid style={{ fontWeight: 'bold' }}>انتخاب نوع ضمانت‌نامه : </Grid>}
                        <RadioGroup
                            onChange={handleChangeRadio}
                            row
                            value={selectedRadioWarrantyType}
                            defaultValue={selectedRadioWarrantyType}
                        >
                            {
                                radioList.map((item, index) => {
                                    return item &&
                                        <FormControlLabel
                                            style={{ display: 'block', width: '100%' }}
                                            value={item?.['warranty-type']}
                                            control={<Radio color="primary" icon={<RadioButtonIcon />} checkedIcon={<RadioButtonIconFill />} />}
                                            label={item?.['name']}
                                        />
                                })
                            }
                        </RadioGroup>
                    </Grid>

                    { // شرط نمایش : باید تایپ دایوانتخاب شده باشه، لودینگ نباشه و سرویس برگشته باشه، خطا نخورده باشه
                        selectedRadioWarrantyType &&
                        !isLoadingSelectRadio &&
                        !isErrorRadioWarrantyService &&
                        <Grid item className={classes.warrantyDetailsBox}>
                            {
                                collpaseItem(warrantyList[0], 0)
                            }
                        </Grid>
                    }
                    {
                        isLoadingSelectRadio && <Grid item className={classes.warrantyDetailsBox}>
                            {
                                shimmerLoading()
                            }
                        </Grid>
                    }
                </Grid>
                {
                    selectedRadioWarrantyType &&
                    !isLoadingSelectRadio &&
                    !isErrorRadioWarrantyService &&
                    <Grid md={6} xs={12} >
                        <Checkbox
                            color="primary"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setTypeWarranty(warrantyList[0]['type']);
                                    setPrice(warrantyList[0]['amount-limit'])
                                } else {
                                    setTypeWarranty(null);
                                }
                            }}
                            icon={<CheckBoxIcon />}
                            checkedIcon={<CheckBoxIconFill />}
                        />
                        <span><u style={{ color: '#2B3990', cursor: 'pointer' }} onClick={() => { setIsOpenDg(true) }}>قوانین و مقررات</u> را مطالعه کردم و موافق هستم.</span>
                    </Grid>
                }
                <Grid direction="row" container item xs={12} justifyContent='flex-end'>
                    <ButtonLoading
                        className={classes.btnSabt}
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={!typeWarranty}
                        name="ثبت و مرحله بعد"
                        onClick={() => { onNextTab('2') }}
                    />
                </Grid>
            </Grid>
            <WarratyTextDg
                setIsOpenDg={setIsOpenDg}
                isOpenDg={isOpenDg}
                data={warrantyList?.[0]?.['warranty-conditions']} />
        </>
    )
}

export default RequestWarranty;
